import { useSelector } from 'react-redux';

import { selectDataClinic } from 'connect/selectors';
import { useOfferService } from 'services/OfferService';

export const useIsOfferAllowed = () => {
  const clinic = useSelector(selectDataClinic);
  const offerService = useOfferService();

  // If there is no active offer, we allow the offer
  if (!offerService.hasActiveOffer) {
    return true;
  }

  return clinic.allowOffers;
};
